import React, { useState } from 'react';
import { getAuth, updateEmail, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
import { ref, update } from 'firebase/database';
import { database } from '../../firebase';
import account from './Account.module.css';

const Account = () => {
    const auth = getAuth();
    const user = auth.currentUser;
    const [name, setName] = useState(user ? user.displayName : '');
    const [email, setEmail] = useState(user ? user.email : '');
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleNameSubmit = async (e) => {
        e.preventDefault();
        try {
            await update(ref(database, `Users/${user.uid}`), { Name: name });
            setMessage('Name updated successfully!');
        } catch (error) {
            setMessage(`Error: ${error.message}`);
        }
    };

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        try {
            await updateEmail(user, email);
            setMessage('Email updated successfully!');
        } catch (error) {
            setMessage(`Error: ${error.message}`);
        }
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        try {
            const credential = EmailAuthProvider.credential(user.email, password);
            await reauthenticateWithCredential(user, credential);
            await updatePassword(user, newPassword);
            setMessage('Password updated successfully!');
        } catch (error) {
            setMessage(`Error: ${error.message}`);
        }
    };

    return (
        <div className={account['account-container']}>
            <div className={account['account-card']}>
                <h2>Update Name</h2>
                <form onSubmit={handleNameSubmit}>
                    <div className={account['form-group']}>
                        <label>New Name</label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter your new name"
                            required
                        />
                    </div>
                    <button type="submit" className={account['account-button']}>Update Name</button>
                </form>
            </div>

            <div className={account['account-card']}>
                <h2>Update Email</h2>
                <form onSubmit={handleEmailSubmit}>
                    <div className={account['form-group']}>
                        <label>New Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your new email"
                            required
                        />
                    </div>
                    <button type="submit" className={account['account-button']}>Update Email</button>
                </form>
            </div>

            <div className={account['account-card']}>
                <h2>Update Password</h2>
                <form onSubmit={handlePasswordSubmit}>
                    <div className={account['form-group']}>
                        <label>Current Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your current password"
                            required
                        />
                    </div>
                    <div className={account['form-group']}>
                        <label>New Password</label>
                        <input
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Enter your new password"
                            required
                        />
                    </div>
                    <button type="submit" className={account['account-button']}>Update Password</button>
                </form>
            </div>

            {message && <p>{message}</p>}

            <div className={account['account-footer']}>
                <a href="/dashboard" className={account['text-link']}>Return to Dashboard</a>
            </div>
        </div>
    );
};

export default Account;